module.exports = __webpack_public_path__ + "static/media/logoline_blanco.776406e5.png";